import { Maybe } from "../../graphql/generated-types"
import { isBrowser } from "../../utils/general"
import { RES_DOMAIN_DATA } from "./middleware"
import { defaultRoutes } from "./setup"
import { DomainData } from "./whitelabeledDomains"

export const defaultRouterHandler = (req, res, app, nextHandler) => {
    const { route, query, parsedUrl } = defaultRoutes.match(req.url)
    if (route) {
        app.render(req, res, route.page, query)
    } else {
        nextHandler(req, res, parsedUrl)
    }
}

export const getFullUrlWithoutSlugs = (fullUrl: string, wlDomain: DomainData) => {
    let fixedUrl = fullUrl
    if (wlDomain.account_slug && fullUrl.includes("/" + wlDomain.account_slug)) {
        fixedUrl = fullUrl.replace("/" + wlDomain.account_slug, "")
    }
    if (wlDomain.terminal_slug && fullUrl.includes("/" + wlDomain.terminal_slug)) {
        fixedUrl = fixedUrl.replace("/" + wlDomain.terminal_slug, "")
    }
    return fixedUrl || "/"
}

export const addSlugsToPath = (path: string, wlDomain: DomainData) => {
    let pathWithSlugs = path
    let slugs = ""

    if (wlDomain.account_slug && !path.includes("/" + wlDomain.account_slug)) {
        slugs = "/" + wlDomain.account_slug
    }
    if (wlDomain.terminal_slug && !path.includes("/" + wlDomain.terminal_slug)) {
        slugs = slugs + "/" + wlDomain.terminal_slug
    }
    pathWithSlugs = slugs + path

    return pathWithSlugs
}

export const getWlDomainDataFromRes = (res: any): Maybe<DomainData> => !isBrowser && res.locals[RES_DOMAIN_DATA]

export const storeClientWlDomainData = (wlDomain: DomainData) => {
    if (isBrowser) {
        window["wlDomainData"] = wlDomain
    }
}

export const getClientWlDomainData = (): Maybe<DomainData> => isBrowser && window["wlDomainData"]
